var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "head_box flex_start flex_center_align" },
      [
        _c("svg-icon", { attrs: { "icon-class": "edit_2_line" } }),
        _c(
          "span",
          { staticClass: "hd_title" },
          [
            _vm._t("hd_title", function () {
              return [_vm._v("報告書一覧")]
            }),
          ],
          2
        ),
      ],
      1
    ),
    _c("div", { staticClass: "h_date" }, [
      _c(
        "span",
        { staticClass: "h_title" },
        [
          _vm._t("h_title", function () {
            return [_vm._v("書類の提出を行ってください")]
          }),
        ],
        2
      ),
    ]),
    _c(
      "div",
      { staticClass: "file_box" },
      [
        _c(
          "vab-row",
          { staticClass: "row_box gray" },
          [
            _c("vab-col", { staticClass: "boxleft", attrs: { span: 4 } }),
            _c("vab-col", { staticClass: "boxleft ht", attrs: { span: 9 } }, [
              _vm._v(" アップロードされたファイル "),
            ]),
            _c("vab-col", { staticClass: "boxleft", attrs: { span: 1 } }),
            _c("vab-col", { staticClass: "boxleft ht", attrs: { span: 10 } }, [
              _vm._v("確認用ファイル"),
            ]),
          ],
          1
        ),
        _vm._l(_vm.fileList, function (item, index) {
          return _c(
            "vab-row",
            { key: index, staticClass: "row_box" },
            [
              _c(
                "vab-col",
                {
                  staticClass: "boxleft gray flex_center_align",
                  attrs: { span: 4 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex_colum" },
                    [
                      _c("div", [
                        _vm._v(" " + _vm._s(item.name) + " "),
                        _c("i", { staticClass: "red" }, [_vm._v("*")]),
                      ]),
                      _c("vab-upload"),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "vab-col",
                { staticClass: "boxleft cpading", attrs: { span: 9 } },
                [
                  index != 3
                    ? _c(
                        "div",
                        { staticClass: "percent" },
                        _vm._l(2, function (son) {
                          return _c(
                            "div",
                            { key: son, staticClass: "inner_box flex_colum" },
                            [
                              _c("span", { staticClass: "fname" }, [
                                _vm._v("エスティーム株式会社"),
                              ]),
                              _c("div", { staticClass: "file_link" }, [
                                _vm._v(
                                  " 〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇" +
                                    _vm._s(item.name) +
                                    ".xlsx "
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex_start ftime_box flex_center_align",
                                },
                                [
                                  _c("span", { staticClass: "time_word" }, [
                                    _vm._v("最終更新日時：2022/09/01 13:55"),
                                  ]),
                                  _c("div", { staticClass: "de_box" }, [
                                    _vm._v("削除"),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "no_file" }, [
                        _vm._v("ファイルがありません"),
                      ]),
                ]
              ),
              _c(
                "vab-col",
                {
                  staticClass: "boxleft flex_center_align flex_center",
                  attrs: { span: 1 },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/file_icon.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
              _c("vab-col", { staticClass: "boxleft", attrs: { span: 10 } }, [
                index != 3
                  ? _c(
                      "div",
                      [
                        _vm.$attrs.type == 1
                          ? [
                              _c(
                                "div",
                                { staticClass: "flex_start flex_end er_box" },
                                [
                                  _c("div", { attrs: { cclass: "img_box2" } }, [
                                    _c("img", {
                                      staticClass: "common_img",
                                      attrs: {
                                        src: require("@/assets/images/r11.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "state_word red" },
                                    [_vm._v("差し戻し")]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "flex_end er_box" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex_start er_box_inner flex_center_align flex_center blue change_blue",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { cclass: "img_box2" } },
                                      [
                                        _c("img", {
                                          staticClass: "common_img",
                                          attrs: {
                                            src: require("@/assets/images/r10.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "state_word blue" },
                                      [_vm._v("提出済み")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          : [
                              _c("div", { staticClass: "flex_end er_box" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex_start er_box_inner flex_center_align flex_center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { cclass: "img_box2" } },
                                      [
                                        _c("img", {
                                          staticClass: "common_img",
                                          attrs: {
                                            src: require("@/assets/images/r11.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "state_word error" },
                                      [_vm._v("差し戻し")]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "flex_end er_box" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex_start er_box_inner flex_center_align flex_center blue",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { cclass: "img_box2" } },
                                      [
                                        _c("img", {
                                          staticClass: "common_img",
                                          attrs: {
                                            src: require("@/assets/images/r10.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "state_word blue" },
                                      [_vm._v("確認")]
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        }),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "bs_btn_main m12" },
      [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }